"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_DIALOG_PADDING = void 0;
exports.calculateMaxWidth = calculateMaxWidth;
const DEFAULT_DIALOG_PADDING = exports.DEFAULT_DIALOG_PADDING = '60px';
function calculateMaxWidth(maxWidth) {
  const numberValue = Number.parseFloat(maxWidth.replaceAll(/\D/g, ''));
  if (maxWidth.slice(-2) === 'vw') {
    if (numberValue > 90) {
      return `calc(${maxWidth} - ${DEFAULT_DIALOG_PADDING})`;
    }
    return maxWidth;
  }
  if (maxWidth.slice(-1) === '%') {
    if (numberValue > 90) {
      return `calc(${maxWidth} - ${DEFAULT_DIALOG_PADDING})`;
    }
    return maxWidth;
  }
  if (maxWidth.slice(-2) === 'px') {
    return `calc(${maxWidth} - ${DEFAULT_DIALOG_PADDING})`;
  }
  return maxWidth;
}
//# sourceMappingURL=calculateMaxWidth.js.map